import Vue from "@/libraries/vue";
import notfound from "@/assets/img/notfound.svg";
import { throwSwal } from "@/assets/js/exceptions";
export default Vue.extend({
    props: {
        value: {
            type: String,
        },
        accept: {
            type: String,
            default: "*",
        },
        selectLabel: {
            type: String,
            default: "Select an image",
        },
        removeLabel: {
            type: String,
            default: "Remove",
        },
        width: String,
        height: String,
        fallback: String,
    },
    data() {
        return {
            notfound: "undefined" !== typeof this.fallback ? this.fallback : notfound,
            imageUrl: "",
            imageFail: false,
        };
    },
    computed: {
        showImg() {
            const imageUrl = this.imageUrl;
            const imageFail = this.imageFail;
            const slotContent = this.slotContent;
            const notErrorImage = !!imageUrl && !imageFail;
            return notErrorImage || !slotContent;
        },
        slot() {
            const slot = this.$slots.default;
            if (!slot)
                return "";
            return slot[0] || "";
        },
        slotContent() {
            const slot = this.slot;
            return !!slot && "<undefined>" != slot.toString();
        },
    },
    watch: {
        value(v) {
            this.imageUrl = v;
            this.imageFail = false;
        },
    },
    mounted() {
        this.imageUrl = this.value;
    },
    methods: {
        imageError(imageUrl) {
            this.imageFail = true;
        },
        onPickFile() {
            const refImage = this.$refs.image;
            refImage.click();
        },
        onFilePicked(event) {
            const files = event.target.files || event.dataTransfer.files;
            if (files && files[0]) {
                const filename = files[0].name;
                if (filename && filename.lastIndexOf(".") <= 0) {
                    return;
                }
                const fileReader = new FileReader();
                fileReader.addEventListener("load", () => {
                    if ("string" !== typeof fileReader.result) {
                        const err = '"string" !== typeof fileReader.result';
                        return throwSwal(err);
                    }
                    this.imageUrl = fileReader.result;
                });
                fileReader.readAsDataURL(files[0]);
                this.$emit("input", files[0]);
            }
        },
        removeFile() {
            this.$emit("input", null);
        },
    },
});
